module.exports = __webpack_public_path__ + "img/cream-puff.f692a5a6.svg";